import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { logger } from 'common-ui';

export function logApiRequest(
  outgoingRequest: AxiosRequestConfig = {},
  incomingResponse: AxiosResponse | undefined = {} as any,
  incomingRequestTime: Date | undefined = new Date(),
  incomingResponseTime: Date | undefined = new Date(),
  handlerName = '',
  message = '',
) {
  logger.log({
    handler: handlerName,
    message,
    outgoingRequest: {
      method: outgoingRequest?.method,
      url: outgoingRequest?.url,
      headers: outgoingRequest?.headers,
      // ISO 8601 date format
      time: incomingRequestTime?.toISOString(),
    },
    incomingResponse: {
      status: incomingResponse?.status,
      headers: incomingResponse?.headers,
      // ISO 8601 date format
      time: incomingResponseTime?.toISOString(),
    },
  });
}
